import logger from '../utils/logger';
export class IframeDetector {
  static isIframe() {
    try {
      return window.self !== window.top || window.parent !== window;
    } catch (e) {
      return true;
    }
  }

  static getParentOrigin() {
    try {
      if (typeof document !== 'undefined' && document.referrer) {
        const url = new URL(document.referrer);
        return `${url.protocol}//${url.host}`;
      }
    } catch (e) {
      logger.error('UTILS', 'Failed to get parent origin:', e);
    }
    return null;
  }
}